import { JsonProperty } from 'json-typescript-mapper';
import { Role } from './role.model';
import { Item } from './item.model';

export class User {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('login')
  public login?: string;

  @JsonProperty('company')
  public company?: string;

  @JsonProperty('firstname')
  public firstname?: string;

  @JsonProperty('lastname')
  public lastname?: string;

  @JsonProperty('email')
  public email?: string;

  @JsonProperty('language')
  public language?: string;

  @JsonProperty('authorityNames')
  public authorityNames?: Role[];

  @JsonProperty('sharedItems')
  public sharedItems?: Item[];

  @JsonProperty('termsAcceptedDate')
  public termsAcceptedDate?: string;

  constructor(
    id?: any,
    login?: string,
    firstname?: string,
    lastname?: string,
    email?: string,
    language?: string,
    authorityNames?: Role[],
    sharedItems?: Item[],
    termsAcceptedDate?: string
  ) {
    this.id = id ? id : null;
    this.login = login ? login : null;
    this.firstname = firstname ? firstname : null;
    this.lastname = lastname ? lastname : null;
    this.email = email ? email : null;
    this.language = language ? language : null;
    this.authorityNames = authorityNames ? authorityNames : [];
    this.sharedItems = sharedItems ? sharedItems : [];
    this.termsAcceptedDate = termsAcceptedDate ? termsAcceptedDate : null;
  }
}
